module.exports = __webpack_public_path__ + "static/media/RENATRE.6da9a48a.svg";